
import { HuntrixSong } from './types';

export const TAKEDOWN: HuntrixSong = {
    id: 'TAKEDOWN',
    title: "Takedown",
    artist: "HUNTR/X",
    midiFileName: "Takedown.mid",
    mp3FileName: "Takedown.mp3",
    sequencedTracks: [
        {
            "name": "Jazz Guitar",
            "notes": [
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "13:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "14:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "15:2:2",
                    "velocity": 0.32
                }
            ]
        },
        {
            "name": "Distortion Guitar",
            "notes": [
                {
                    "name": "C#2",
                    "duration": "1m",
                    "time": "0:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "1m",
                    "time": "0:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "4:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "5:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "5:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "6:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "6:2:0",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "6:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "7:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "7:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "8:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "8:2:0",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "8:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "9:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "9:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "10:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "10:2:0",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "10:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "11:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "11:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "12:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "12:2:0",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "12:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "13:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#3",
                    "duration": "2n",
                    "time": "13:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "13:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "13:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "13:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "8n",
                    "time": "14:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#3",
                    "duration": "8n",
                    "time": "14:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "8n",
                    "time": "14:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "14:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "14:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "14:2:0",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "14:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "15:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "15:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "15:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "15:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "8n",
                    "time": "16:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#3",
                    "duration": "8n",
                    "time": "16:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "8n",
                    "time": "16:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "16:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "16:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "16:2:0",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "16:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "17:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#3",
                    "duration": "2n",
                    "time": "17:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "17:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "17:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "17:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "8n",
                    "time": "18:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#3",
                    "duration": "8n",
                    "time": "18:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "8n",
                    "time": "18:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "18:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "18:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "18:2:0",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "18:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "2n",
                    "time": "19:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#3",
                    "duration": "2n",
                    "time": "19:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "20:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "20:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "20:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "20:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "21:0:2",
                    "velocity": 0.32
                },
                {
                    "name": "B2",
                    "duration": "8n",
                    "time": "21:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#3",
                    "duration": "8n",
                    "time": "21:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "21:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "B2",
                    "duration": "8n",
                    "time": "21:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "B3",
                    "duration": "4n",
                    "time": "22:0:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "22:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "22:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "22:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "22:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "23:0:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "8n",
                    "time": "23:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "23:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "23:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "23:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "24:0:2",
                    "velocity": 0.32
                },
                {
                    "name": "E3",
                    "duration": "4n",
                    "time": "24:0:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "24:0:2",
                    "velocity": 0.32
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "24:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "16n",
                    "time": "24:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "24:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "16n",
                    "time": "25:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "25:0:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "16n",
                    "time": "25:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "25:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "25:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "25:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "25:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "26:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "26:0:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "26:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "26:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "16n",
                    "time": "26:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "26:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "26:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "27:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "27:0:2",
                    "velocity": 0.32
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "27:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "27:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "27:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "16n",
                    "time": "27:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "27:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "16n",
                    "time": "28:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "28:0:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "16n",
                    "time": "28:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "28:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#5",
                    "duration": "2n",
                    "time": "29:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "29:2:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "29:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "29:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "30:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "30:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "30:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "30:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "30:3:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "30:3:2",
                    "velocity": 0.37
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "30:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "31:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "2n",
                    "time": "31:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "31:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "31:2:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "31:2:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "31:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "31:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "32:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "32:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "32:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "32:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "32:3:2",
                    "velocity": 0.37
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "32:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "33:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "33:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "33:1:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "33:2:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "33:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "33:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "34:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "34:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "34:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "34:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "34:3:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "34:3:2",
                    "velocity": 0.37
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "34:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "35:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "2n",
                    "time": "35:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "35:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "35:2:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "35:2:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "35:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "35:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "36:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "36:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "36:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "36:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "4n",
                    "time": "36:3:2",
                    "velocity": 0.37
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "36:3:2",
                    "velocity": 0.37
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "36:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "37:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "37:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "37:1:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "37:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "37:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "38:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "38:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "38:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "39:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "39:2:0",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "39:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "40:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "40:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "41:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "41:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "41:2:0",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "41:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "42:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "42:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "42:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "43:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "43:2:0",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "43:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "44:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "44:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "45:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "45:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "2n",
                    "time": "46:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#3",
                    "duration": "2n",
                    "time": "46:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "46:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "8n",
                    "time": "47:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#3",
                    "duration": "8n",
                    "time": "47:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "47:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "47:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "47:2:0",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "47:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "2n",
                    "time": "48:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#3",
                    "duration": "2n",
                    "time": "48:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "49:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "49:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "49:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "49:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "50:0:2",
                    "velocity": 0.32
                },
                {
                    "name": "B2",
                    "duration": "8n",
                    "time": "50:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#3",
                    "duration": "8n",
                    "time": "50:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "50:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "B2",
                    "duration": "8n",
                    "time": "50:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "B3",
                    "duration": "4n",
                    "time": "51:0:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "51:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "51:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "51:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "51:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "52:0:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "8n",
                    "time": "52:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "52:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "52:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "52:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "53:0:2",
                    "velocity": 0.32
                },
                {
                    "name": "E3",
                    "duration": "4n",
                    "time": "53:0:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "53:0:2",
                    "velocity": 0.32
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "53:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "16n",
                    "time": "53:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "53:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "16n",
                    "time": "54:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "54:0:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "16n",
                    "time": "54:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "54:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "54:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "54:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "54:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "55:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "55:0:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "55:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "55:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "16n",
                    "time": "55:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "55:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "55:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "56:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "56:0:2",
                    "velocity": 0.32
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "56:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "56:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "56:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "16n",
                    "time": "56:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "56:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "16n",
                    "time": "57:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "57:0:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "16n",
                    "time": "57:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "57:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#5",
                    "duration": "2n",
                    "time": "58:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "58:2:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "58:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "58:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "59:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "59:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "59:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "59:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "59:3:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "59:3:2",
                    "velocity": 0.37
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "59:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "60:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "2n",
                    "time": "60:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "60:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "60:2:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "60:2:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "60:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "60:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "61:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "61:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "61:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "61:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "61:3:2",
                    "velocity": 0.37
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "61:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "62:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "62:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "62:1:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "62:2:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "62:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "62:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "63:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "63:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "63:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "63:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "63:3:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "63:3:2",
                    "velocity": 0.37
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "63:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "64:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "2n",
                    "time": "64:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "64:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "64:2:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "64:2:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "64:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "64:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "65:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "65:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "65:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "65:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "4n",
                    "time": "65:3:2",
                    "velocity": 0.37
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "65:3:2",
                    "velocity": 0.37
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "65:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "66:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "66:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "66:1:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "66:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#5",
                    "duration": "2n",
                    "time": "85:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "85:2:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "85:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "85:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "86:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "86:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "86:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "86:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "86:3:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "86:3:2",
                    "velocity": 0.37
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "86:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "87:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "2n",
                    "time": "87:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "87:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "87:2:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "87:2:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "87:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "87:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "88:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "88:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "88:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "88:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "88:3:2",
                    "velocity": 0.37
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "88:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "89:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "89:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "89:1:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "89:2:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "89:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "89:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "90:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "90:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "90:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "90:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "90:3:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "90:3:2",
                    "velocity": 0.37
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "90:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "91:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "2n",
                    "time": "91:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "91:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "91:2:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "91:2:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "91:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "91:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "92:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "92:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "92:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "92:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "4n",
                    "time": "92:3:2",
                    "velocity": 0.37
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "92:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "92:3:2",
                    "velocity": 0.37
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "93:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "93:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "93:1:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "93:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "93:2:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "93:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "93:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "94:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "94:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "94:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "94:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "94:3:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "94:3:2",
                    "velocity": 0.37
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "94:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "95:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "2n",
                    "time": "95:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "95:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "95:2:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "95:2:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "95:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "95:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "96:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "96:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "96:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "96:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "96:3:2",
                    "velocity": 0.37
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "96:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "97:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "97:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "97:1:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "97:2:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "97:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "97:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "98:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "98:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "98:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "98:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "98:3:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "98:3:2",
                    "velocity": 0.37
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "98:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "99:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "2n",
                    "time": "99:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "99:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "99:2:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "99:2:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "99:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "99:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "100:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "100:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "100:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "100:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "4n",
                    "time": "100:3:2",
                    "velocity": 0.37
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "100:3:2",
                    "velocity": 0.37
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "100:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "101:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "101:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "101:1:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "101:1:2",
                    "velocity": 0.37
                }
            ]
        },
        {
            "name": "Bass",
            "notes": [
                {
                    "name": "C#2",
                    "duration": "1m",
                    "time": "0:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "1m",
                    "time": "0:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "4:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "5:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "5:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "6:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "6:2:0",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "6:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "7:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "7:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "8:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "8:2:0",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "8:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "9:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "9:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "10:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "10:2:0",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "10:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "11:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "11:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "12:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "12:2:0",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "12:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "2n",
                    "time": "13:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#3",
                    "duration": "2n",
                    "time": "13:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "13:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "8n",
                    "time": "14:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#3",
                    "duration": "8n",
                    "time": "14:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "14:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "14:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "14:2:0",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "14:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "2n",
                    "time": "15:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "15:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "8n",
                    "time": "16:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#3",
                    "duration": "8n",
                    "time": "16:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "16:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "16:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "16:2:0",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "16:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "2n",
                    "time": "17:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#3",
                    "duration": "2n",
                    "time": "17:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "17:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "8n",
                    "time": "18:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#3",
                    "duration": "8n",
                    "time": "18:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "18:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "18:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "18:2:0",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "18:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "2n",
                    "time": "19:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#3",
                    "duration": "2n",
                    "time": "19:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "20:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "20:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "20:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "20:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "21:0:2",
                    "velocity": 0.32
                },
                {
                    "name": "B2",
                    "duration": "8n",
                    "time": "21:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#3",
                    "duration": "8n",
                    "time": "21:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "21:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "B2",
                    "duration": "8n",
                    "time": "21:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "B3",
                    "duration": "4n",
                    "time": "22:0:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "22:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "22:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "22:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "22:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "23:0:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "8n",
                    "time": "23:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "23:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "23:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "23:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "24:0:2",
                    "velocity": 0.32
                },
                {
                    "name": "E3",
                    "duration": "4n",
                    "time": "24:0:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "24:0:2",
                    "velocity": 0.32
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "24:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "16n",
                    "time": "24:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "24:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "16n",
                    "time": "25:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "25:0:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "16n",
                    "time": "25:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "25:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "25:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "25:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "25:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "26:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "26:0:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "26:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "26:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "16n",
                    "time": "26:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "26:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "26:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "27:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "27:0:2",
                    "velocity": 0.32
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "27:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "27:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "27:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "16n",
                    "time": "27:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "27:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "16n",
                    "time": "28:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "28:0:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "16n",
                    "time": "28:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "28:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "29:2:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "30:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "30:3:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "30:3:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "31:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "31:2:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "31:2:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "32:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "32:3:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "33:1:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "33:2:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "34:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "34:3:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "34:3:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "35:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "35:2:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "35:2:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "36:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "36:3:2",
                    "velocity": 0.37
                },
                {
                    "name": "G#1",
                    "duration": "4n",
                    "time": "36:3:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "37:1:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "37:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "37:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "38:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "38:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "38:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "39:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "39:2:0",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "39:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "40:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "40:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "41:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "41:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "41:2:0",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "41:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "42:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "42:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "42:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "43:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "43:2:0",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "43:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "44:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "44:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "45:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "45:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "2n",
                    "time": "46:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#3",
                    "duration": "2n",
                    "time": "46:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "46:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "8n",
                    "time": "47:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#3",
                    "duration": "8n",
                    "time": "47:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "47:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "47:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "47:2:0",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "47:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "2n",
                    "time": "48:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#3",
                    "duration": "2n",
                    "time": "48:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "49:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "49:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "49:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "49:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "50:0:2",
                    "velocity": 0.32
                },
                {
                    "name": "B2",
                    "duration": "8n",
                    "time": "50:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#3",
                    "duration": "8n",
                    "time": "50:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "50:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "B2",
                    "duration": "8n",
                    "time": "50:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "B3",
                    "duration": "4n",
                    "time": "51:0:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "51:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "51:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "51:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "51:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "52:0:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "8n",
                    "time": "52:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "52:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "52:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "52:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "53:0:2",
                    "velocity": 0.32
                },
                {
                    "name": "E3",
                    "duration": "4n",
                    "time": "53:0:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "53:0:2",
                    "velocity": 0.32
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "53:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "16n",
                    "time": "53:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "53:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "16n",
                    "time": "54:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "54:0:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "16n",
                    "time": "54:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "54:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "54:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "54:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "54:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "55:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "55:0:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "55:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "55:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "16n",
                    "time": "55:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "55:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "55:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "56:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "56:0:2",
                    "velocity": 0.32
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "56:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "56:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "56:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "16n",
                    "time": "56:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "56:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "16n",
                    "time": "57:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "57:0:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "16n",
                    "time": "57:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "57:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "58:2:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "59:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "59:3:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "59:3:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "60:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "60:2:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "60:2:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "61:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "61:3:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "62:1:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "62:2:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "63:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "63:3:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "63:3:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "64:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "64:2:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "64:2:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "65:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "65:3:2",
                    "velocity": 0.37
                },
                {
                    "name": "G#1",
                    "duration": "4n",
                    "time": "65:3:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "66:1:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "66:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "F#2",
                    "duration": "1m",
                    "time": "74:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "A2",
                    "duration": "1m",
                    "time": "75:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "C#3",
                    "duration": "1m",
                    "time": "76:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "B2",
                    "duration": "2n",
                    "time": "77:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "78:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "78:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "1m",
                    "time": "78:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "A2",
                    "duration": "1m",
                    "time": "79:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "C#3",
                    "duration": "1m",
                    "time": "80:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "G#2",
                    "duration": "1m",
                    "time": "81:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "85:2:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "86:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "86:3:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "86:3:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "87:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "87:2:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "87:2:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "88:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "88:3:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "89:1:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "89:2:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "90:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "90:3:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "90:3:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "91:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "91:2:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "91:2:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "92:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "G#1",
                    "duration": "4n",
                    "time": "92:3:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "93:1:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "93:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "93:2:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "94:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "94:3:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "94:3:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "95:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "95:2:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "95:2:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "96:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "96:3:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "97:1:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "97:2:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "98:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "98:3:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "98:3:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "99:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "99:2:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "99:2:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "100:1:2",
                    "velocity": 0.37
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "100:3:2",
                    "velocity": 0.37
                },
                {
                    "name": "G#1",
                    "duration": "4n",
                    "time": "100:3:2",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "101:1:0",
                    "velocity": 0.37
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "101:1:2",
                    "velocity": 0.37
                }
            ]
        },
        {
            "name": "808 Drum Kit",
            "notes": [
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "0:2:2",
                    "velocity": 0.31
                },
                {
                    "name": "B1",
                    "duration": "4n",
                    "time": "0:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "0:3:2",
                    "velocity": 0.31
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "1:0:2",
                    "velocity": 0.31
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "1:1:2",
                    "velocity": 0.31
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "1:2:2",
                    "velocity": 0.31
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "1:3:2",
                    "velocity": 0.31
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "2:0:2",
                    "velocity": 0.31
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "2:1:2",
                    "velocity": 0.31
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "2:2:2",
                    "velocity": 0.31
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "2:3:2",
                    "velocity": 0.31
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "3:0:2",
                    "velocity": 0.31
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "3:1:2",
                    "velocity": 0.31
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "3:2:2",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "4:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "4:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "4:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "5:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "5:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "5:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "5:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "6:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "6:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "6:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "6:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "6:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "7:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "7:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "7:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "7:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "8:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "8:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "8:2:3",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "8:2:4",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "8:3:1",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "8:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "8:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "8:3:4",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "9:0:1",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "9:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "9:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "9:0:4",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "9:1:1",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "9:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "9:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "9:1:4",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "9:2:1",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "9:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "9:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "9:2:3",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "9:2:4",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "9:3:1",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "9:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "9:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "9:3:4",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "10:0:1",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "10:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "10:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "10:0:4",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "10:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "10:1:1",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "10:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "10:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "10:1:4",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "10:2:1",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "10:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "10:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "10:2:3",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "10:2:4",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "10:3:1",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "10:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "10:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "10:3:4",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "11:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "11:0:1",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "11:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "11:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "11:0:4",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "11:1:1",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "11:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "11:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "11:1:4",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "11:2:1",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "11:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "11:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "11:2:3",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "11:2:4",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "11:3:1",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "11:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "11:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "11:3:4",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "12:0:1",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "12:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "12:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "12:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "12:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "12:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "12:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "12:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "12:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "12:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "13:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "13:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "13:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "13:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "13:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "13:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "13:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "13:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "13:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "13:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "13:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "13:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "14:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "14:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "14:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "14:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "14:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "14:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "14:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "14:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "14:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "14:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "14:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "14:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "14:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "15:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "15:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "15:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "15:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "15:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "15:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "15:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "15:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "15:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "15:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "15:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "15:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "16:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "16:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "16:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "16:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "16:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "16:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "16:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "16:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "16:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "16:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "16:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "16:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "16:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "17:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "17:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "17:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "17:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "17:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "17:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "17:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "17:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "17:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "17:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "17:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "17:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "18:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "18:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "18:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "18:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "18:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "18:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "18:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "18:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "18:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "18:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "18:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "18:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "18:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "19:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "19:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "19:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "19:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "19:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "19:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "19:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "19:2:2",
                    "velocity": 0.31
                },
                {
                    "name": "B1",
                    "duration": "4n",
                    "time": "19:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "20:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "20:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "21:0:2",
                    "velocity": 0.31
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "21:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "21:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "22:0:2",
                    "velocity": 0.31
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "22:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "22:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "23:0:2",
                    "velocity": 0.31
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "23:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "23:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "24:0:2",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "24:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "24:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "24:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "24:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "24:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "24:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "24:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "24:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "24:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "24:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "24:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "25:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "25:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "25:0:2",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "25:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "25:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "25:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "25:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "25:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "25:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "25:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "25:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "25:2:1",
                    "velocity": 0.16
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "25:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "25:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "25:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "25:2:3",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "25:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "25:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "25:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "25:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "25:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "26:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "26:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "26:0:2",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "26:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "26:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "26:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "26:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "26:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "26:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "26:1:3",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "26:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "26:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "26:2:1",
                    "velocity": 0.16
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "26:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "26:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "26:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "26:2:3",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "26:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "26:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "26:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "26:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "26:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "27:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "27:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "27:0:2",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "27:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "27:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "27:0:3",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "27:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "27:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "27:1:1",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "27:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "27:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "27:1:3",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "27:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "27:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "27:2:1",
                    "velocity": 0.16
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "27:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "27:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "27:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "27:2:3",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "27:2:4",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "27:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "27:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "27:3:1",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "27:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "27:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "27:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "27:3:3",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "27:3:4",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "28:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "28:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "28:0:1",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "28:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "28:0:2",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "28:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "29:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "29:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "29:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "29:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "30:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "30:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "30:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "30:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "30:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "30:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "30:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "30:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "30:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "30:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "30:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "31:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "31:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "31:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "31:1:1",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "31:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "31:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "31:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "31:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "31:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "31:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "32:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "32:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "32:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "32:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "32:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "32:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "32:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "32:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "32:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "32:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "32:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "33:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "33:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "33:0:3",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "33:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "33:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "33:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "33:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "33:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "33:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "33:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "33:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "34:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "34:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "34:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "34:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "34:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "34:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "34:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "34:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "34:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "34:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "34:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "35:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "35:0:1",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "35:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "35:0:3",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "35:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "35:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "35:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "35:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "35:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "35:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "35:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "35:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "35:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "36:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "36:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "36:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "37:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "37:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "37:0:3",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "37:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "37:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "37:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "37:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "37:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "37:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "37:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "37:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "37:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "38:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "38:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "38:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "38:1:1",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "38:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "38:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "38:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "38:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "38:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "38:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "38:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "38:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "39:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "39:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "39:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "39:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "39:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "39:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "39:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "39:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "39:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "39:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:0:3",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "40:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "40:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "40:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "41:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "41:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "41:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "41:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "41:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "41:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "41:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "41:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "41:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "41:2:3",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "41:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "41:3:1",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "41:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "41:3:3",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:0:1",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:0:3",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:1:1",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:1:3",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "42:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:2:1",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:2:3",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:3:1",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "42:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:3:3",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "43:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "43:0:1",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "43:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "43:0:3",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "43:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "43:1:1",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "43:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "43:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "43:1:3",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "43:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "43:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "43:2:1",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "43:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "43:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "43:2:3",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "43:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "43:3:1",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "43:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "43:3:3",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:0:1",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:0:3",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:1:1",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:1:3",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "44:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:2:1",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:2:3",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "44:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:3:1",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "44:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:3:3",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:0:1",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "45:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "45:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:2:3",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:2:4",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:3:1",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "45:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:3:4",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:0:1",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "46:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:0:4",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:1:1",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "46:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:1:4",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:2:1",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "46:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:2:3",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:2:4",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:3:1",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "46:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:3:4",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "47:0:1",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "47:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "47:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "47:0:4",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "47:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "47:1:1",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "47:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "47:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "47:1:4",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "47:2:1",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "47:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "47:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "47:2:3",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "47:2:4",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "47:3:1",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "47:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "47:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "47:3:4",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "48:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "48:0:1",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "48:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "48:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "48:0:4",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "48:1:1",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "48:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "48:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "48:1:4",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "48:2:1",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "48:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "4n",
                    "time": "48:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "49:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "49:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "50:0:2",
                    "velocity": 0.31
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "50:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "50:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "51:0:2",
                    "velocity": 0.31
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "51:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "51:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "52:0:2",
                    "velocity": 0.31
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "52:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "52:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "53:0:2",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "53:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "53:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "53:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "53:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "53:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "53:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "53:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "53:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "53:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "53:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "53:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "54:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "54:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "54:0:2",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "54:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "54:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "54:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "54:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "54:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "54:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "54:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "54:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "54:2:1",
                    "velocity": 0.16
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "54:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "54:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "54:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "54:2:3",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "54:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "54:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "54:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "54:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "54:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "55:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "55:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "55:0:2",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "55:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "55:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "55:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "55:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "55:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "55:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "55:1:3",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "55:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "55:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "55:2:1",
                    "velocity": 0.16
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "55:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "55:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "55:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "55:2:3",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "55:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "55:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "55:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "55:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "55:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "56:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "56:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "56:0:2",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "56:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "56:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "56:0:3",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "56:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "56:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "56:1:1",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "56:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "56:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "56:1:3",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "56:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "56:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "56:2:1",
                    "velocity": 0.16
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "56:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "56:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "56:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "56:2:3",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "56:2:4",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "56:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "56:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "56:3:1",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "56:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "56:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "56:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "56:3:3",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "56:3:4",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "57:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "57:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "57:0:1",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "57:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "57:0:2",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "57:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "58:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "58:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "58:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "58:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "59:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "59:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "59:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "59:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "59:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "59:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "59:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "59:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "59:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "59:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "59:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "60:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "60:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "60:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "60:1:1",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "60:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "60:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "60:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "60:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "60:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "60:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "61:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "61:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "61:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "61:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "61:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "61:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "61:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "61:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "61:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "61:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "61:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "62:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "62:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "62:0:3",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "62:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "62:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "62:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "62:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "62:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "62:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "62:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "62:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "63:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "63:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "63:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "63:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "63:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "63:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "63:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "63:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "63:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "63:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "63:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "64:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "64:0:1",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "64:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "64:0:3",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "64:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "64:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "64:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "64:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "64:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "64:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "64:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "64:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "64:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "65:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "65:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "65:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "65:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "65:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "65:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "65:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "65:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "65:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "65:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "65:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "66:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "66:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "66:0:3",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "66:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "66:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "66:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "66:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "66:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "4n",
                    "time": "66:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "74:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "74:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "75:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "75:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "75:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "75:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "76:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "76:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "76:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "76:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "77:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "77:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "77:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "77:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "78:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "78:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "78:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "78:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "78:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "79:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "79:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "79:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "79:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "79:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "79:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "79:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "79:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "80:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "80:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "80:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "80:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "80:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "80:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "80:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "80:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "81:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "81:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "81:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "81:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "81:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "81:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "81:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "81:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "82:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "82:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "82:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "82:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "82:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "4n",
                    "time": "82:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "85:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "85:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "85:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "86:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "86:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "86:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "86:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "86:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "86:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "86:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "86:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "86:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "86:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "86:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "87:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "87:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "87:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "87:1:1",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "87:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "87:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "87:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "87:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "87:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "87:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "88:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "88:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "88:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "88:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "88:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "88:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "88:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "88:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "88:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "88:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "88:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "89:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "89:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "89:0:3",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "89:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "89:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "89:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "89:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "89:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "89:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "89:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "89:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "90:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "90:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "90:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "90:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "90:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "90:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "90:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "90:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "90:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "90:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "90:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "91:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "91:0:1",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "91:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "91:0:3",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "91:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "91:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "91:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "91:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "91:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "91:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "91:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "91:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "91:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "92:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "92:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "92:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "92:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "92:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "92:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "92:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "92:2:2",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "92:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "92:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "92:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "92:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "92:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "92:3:2",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "92:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "93:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "93:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "93:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "93:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "93:0:2",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "93:0:3",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "93:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "93:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "93:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "93:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "93:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "93:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "93:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "93:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "93:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "93:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "93:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "93:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "93:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "93:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "93:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "93:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "93:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "94:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "94:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "94:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "94:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "94:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "94:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "94:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "94:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "94:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "94:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "94:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "94:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "94:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "94:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "94:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "94:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "94:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "94:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "95:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "95:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "95:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "95:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "95:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "95:1:1",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "95:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "95:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "95:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "95:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "95:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "95:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "95:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "95:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "95:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "95:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "95:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "95:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "95:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "96:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "96:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "96:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "96:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "96:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "96:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "96:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "96:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "96:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "96:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "96:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "96:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "96:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "96:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "96:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "96:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "96:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "96:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "97:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "97:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "97:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "97:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "97:0:3",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "97:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "97:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "97:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "97:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "97:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "97:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "97:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "97:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "97:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "97:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "97:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "97:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "97:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "97:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "98:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "98:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "98:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "98:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "98:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "98:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "98:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "98:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "98:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "98:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "98:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "98:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "98:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "98:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "98:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "98:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "98:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "98:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "99:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "99:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "99:0:1",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "99:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "99:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "99:0:3",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "99:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "99:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "99:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "99:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "99:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "99:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "99:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "99:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "99:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "99:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "99:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "99:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "99:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "99:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "100:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "100:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "100:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "100:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "100:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "100:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "100:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "100:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "100:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "100:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "100:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "100:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "100:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "100:3:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "100:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "100:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "100:3:2",
                    "velocity": 0.12
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "100:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "101:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "101:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "101:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "101:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "101:0:3",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "101:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "101:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "101:1:2",
                    "velocity": 0.12
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "101:2:0",
                    "velocity": 0.12
                },
                {
                    "name": "B1",
                    "duration": "1m",
                    "time": "101:2:2",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "Synth Pluck",
            "notes": [
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "4:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "4:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "4:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "5:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "5:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "5:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "5:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "5:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "5:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "5:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "5:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "6:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "6:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "6:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "6:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "6:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "6:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "6:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "6:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "7:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "7:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "7:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "7:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "7:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "7:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "7:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "7:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "8:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "8:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "8:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "8:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "8:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "8:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "8:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "8:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "9:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "9:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "9:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "9:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "9:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "9:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "9:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "9:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "10:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "10:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "10:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "10:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "10:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "10:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "10:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "10:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "11:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "11:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "11:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "11:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "11:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "11:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "11:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "11:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "12:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "12:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "12:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "12:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "12:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "12:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "12:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "12:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "12:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "12:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "13:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "13:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "13:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "13:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "13:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "13:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "13:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "13:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "13:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "13:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "13:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "13:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "14:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "14:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "14:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "14:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "14:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "14:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "14:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "14:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "14:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "14:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "14:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "14:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "15:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "15:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "15:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "15:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "15:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "15:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "15:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "15:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "15:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "15:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "15:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "15:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "15:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "15:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "16:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "16:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "16:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "16:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "16:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "16:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "16:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "16:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "16:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "16:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "16:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "17:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "17:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "17:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "17:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "17:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "17:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "17:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "17:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "17:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "17:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "17:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "17:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "17:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "17:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "18:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "18:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "18:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "18:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "18:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "18:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "18:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "18:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "18:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "18:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "18:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "19:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "19:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "19:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "19:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "19:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "19:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "20:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "20:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "20:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "21:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "21:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "21:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "21:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "21:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "21:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "21:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "21:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "22:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "22:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "22:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "22:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "22:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "22:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "22:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "22:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "23:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "23:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "23:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "23:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "23:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "23:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "23:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "23:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "24:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "24:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "24:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "24:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "24:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "24:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "24:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "24:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "25:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "25:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "25:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "25:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "25:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "25:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "25:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "26:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "26:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "26:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "26:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "26:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "26:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "26:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "26:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "27:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "27:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "27:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "27:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "27:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "27:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "27:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "27:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "28:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "28:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "28:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "28:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "28:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "29:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "29:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "29:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "29:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "29:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "30:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "30:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "30:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "30:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "30:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "30:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "30:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "30:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "30:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "30:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "30:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "30:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "30:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "30:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "31:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "31:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "31:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "31:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "31:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "31:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "31:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "31:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "31:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "31:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "31:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "31:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "32:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "32:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "32:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "32:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "32:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "32:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "32:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "32:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "32:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "32:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "32:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "32:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "32:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "32:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "33:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "33:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "33:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "33:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "33:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "33:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "33:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "33:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "33:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "33:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "33:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "33:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "34:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "34:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "34:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "34:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "34:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "34:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "34:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "34:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "34:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "34:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "34:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "34:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "34:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "34:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "35:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "35:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "35:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "35:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "35:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "35:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "35:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "35:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "35:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "35:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "35:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "35:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "36:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "36:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "36:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "36:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "36:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "36:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "36:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "36:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "36:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "36:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "45:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "45:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "45:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "45:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "46:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "46:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "46:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "46:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "46:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "46:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "46:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "46:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "46:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "46:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "46:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "46:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "47:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "47:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "47:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "47:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "47:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "47:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "47:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "47:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "47:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "47:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "48:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "48:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "48:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "48:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "48:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "48:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "48:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "49:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "49:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "49:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "50:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "50:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "50:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "50:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "50:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "50:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "50:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "50:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "51:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "51:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "51:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "51:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "51:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "51:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "51:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "51:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "52:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "52:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "52:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "52:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "52:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "52:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "52:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "52:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "53:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "53:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "53:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "53:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "53:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "53:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "53:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "53:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "54:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "54:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "54:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "54:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "54:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "54:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "54:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "55:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "55:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "55:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "55:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "55:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "55:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "55:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "55:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "56:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "56:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "56:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "56:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "56:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "56:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "56:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "56:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "57:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "57:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "57:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "57:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "57:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "58:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "58:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "58:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "58:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "58:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "59:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "59:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "59:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "59:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "59:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "59:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "59:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "59:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "59:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "59:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "59:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "59:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "59:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "59:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "60:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "60:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "60:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "60:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "60:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "60:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "60:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "60:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "60:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "60:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "60:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "60:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "61:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "61:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "61:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "61:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "61:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "61:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "61:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "61:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "61:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "61:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "61:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "61:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "61:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "61:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "62:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "62:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "62:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "62:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "62:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "62:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "62:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "62:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "62:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "62:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "62:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "62:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "63:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "63:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "63:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "63:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "63:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "63:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "63:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "63:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "63:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "63:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "63:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "63:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "63:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "63:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "64:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "64:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "64:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "64:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "64:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "64:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "64:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "64:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "64:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "64:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "64:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "64:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "65:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "65:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "65:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "65:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "65:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "65:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "65:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "65:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "65:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "65:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "75:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "75:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#3",
                    "duration": "8n",
                    "time": "75:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "75:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "75:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "75:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "76:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "76:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#3",
                    "duration": "8n",
                    "time": "76:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "76:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "76:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "76:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "76:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "76:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "76:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "76:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "76:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "76:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#3",
                    "duration": "8n",
                    "time": "77:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "77:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "8n",
                    "time": "77:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "77:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "77:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "77:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "77:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "77:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#3",
                    "duration": "8n",
                    "time": "78:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "78:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "8n",
                    "time": "78:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "78:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "78:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "78:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "79:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "79:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#3",
                    "duration": "8n",
                    "time": "79:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "79:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "79:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "79:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "80:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "80:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#3",
                    "duration": "8n",
                    "time": "80:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "80:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "80:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "80:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "80:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "80:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "80:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "80:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "80:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "80:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#3",
                    "duration": "8n",
                    "time": "81:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "81:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "8n",
                    "time": "81:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "81:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "81:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "81:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "81:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "81:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#3",
                    "duration": "8n",
                    "time": "82:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "82:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "2n",
                    "time": "82:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "2n",
                    "time": "82:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "85:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "85:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "85:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "85:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "85:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "86:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "86:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "86:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "86:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "86:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "86:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "86:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "86:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "86:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "86:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "86:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "86:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "86:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "86:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "87:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "87:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "87:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "87:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "87:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "87:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "87:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "87:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "87:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "87:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "87:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "87:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "88:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "88:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "88:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "88:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "88:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "88:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "88:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "88:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "88:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "88:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "88:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "88:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "88:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "88:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "89:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "89:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "89:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "89:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "89:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "89:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "89:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "89:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "89:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "89:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "89:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "89:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "90:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "90:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "90:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "90:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "90:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "90:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "90:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "90:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "90:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "90:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "90:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "90:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "90:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "90:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "91:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "91:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "91:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "91:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "91:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "91:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "91:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "91:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "91:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "91:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "91:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "91:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "92:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "92:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "92:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "92:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "92:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "92:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "92:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "92:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "92:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "92:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "92:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "92:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "93:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "93:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "93:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "93:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "93:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "93:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "93:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "93:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "93:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "93:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "94:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "94:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "94:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "94:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "94:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "94:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "94:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "94:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "94:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "94:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "94:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "94:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "94:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "94:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "95:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "95:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "95:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "95:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "95:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "95:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "95:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "95:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "95:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "95:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "95:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "95:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "96:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "96:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "96:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "96:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "96:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "96:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "96:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "96:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "96:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "96:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "96:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "96:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "96:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "96:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "97:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "97:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "97:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "97:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "97:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "97:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "97:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "97:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "97:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "97:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "97:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "97:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "98:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "98:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "98:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "98:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "98:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "98:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "98:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "98:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "98:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "98:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "98:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "98:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "98:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "98:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "99:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "99:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "99:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "99:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "99:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "99:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "99:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "99:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "99:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "99:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "99:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "99:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "100:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "100:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "100:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "100:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "100:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "100:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "100:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "100:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "100:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "100:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "100:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "100:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "101:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "101:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "101:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "101:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "101:2:0",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "909 Drum Kit",
            "notes": [
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "0:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "4n",
                    "time": "0:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "4:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "4:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "4:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "5:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "5:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "5:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "5:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "6:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "6:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "6:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "6:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "6:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "7:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "7:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "7:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "7:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "8:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "8:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "9:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "9:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "9:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "9:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "10:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "10:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "10:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "10:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "10:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "11:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "11:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "11:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "11:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "12:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "12:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "12:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "12:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "12:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "13:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "13:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "13:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "13:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "14:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "14:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "14:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "14:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "14:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "15:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "15:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "15:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "15:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "16:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "16:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "16:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "16:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "16:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "17:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "17:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "17:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "17:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "18:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "18:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "18:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "18:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "18:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "19:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "19:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "19:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "4n",
                    "time": "19:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "20:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "20:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "21:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "21:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "22:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "22:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "23:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "23:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "24:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "24:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "25:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "25:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "26:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "26:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "27:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "27:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "29:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "30:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "30:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "30:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "30:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "31:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "31:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "32:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "32:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "32:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "32:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "33:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "33:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "33:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "34:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "34:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "34:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "34:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "35:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "35:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "35:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "35:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "36:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "36:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "36:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "36:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "37:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "37:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "37:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "37:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "38:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "38:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "38:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "38:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "39:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "39:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "39:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "40:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "40:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "40:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "40:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "41:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "41:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "41:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "41:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "42:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "42:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "42:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "43:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "43:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "43:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "43:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "44:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "44:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "44:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "44:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "45:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "45:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "45:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "46:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "46:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "46:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "46:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "47:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "47:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "47:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "47:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "47:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "48:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "48:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "48:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "4n",
                    "time": "48:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "49:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "49:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "50:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "50:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "51:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "51:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "52:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "52:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "53:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "53:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "54:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "54:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "55:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "55:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "56:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "56:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "58:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "59:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "59:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "59:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "59:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "60:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "60:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "61:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "61:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "61:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "61:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "62:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "62:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "62:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "63:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "63:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "63:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "63:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "64:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "64:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "64:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "64:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "65:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "65:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "65:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "65:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "66:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "66:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "66:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "66:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "4n",
                    "time": "66:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "74:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "74:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "75:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "75:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "75:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "75:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "76:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "76:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "76:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "76:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "77:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "77:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "77:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "77:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "78:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "78:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "78:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "78:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "78:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "79:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "79:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "79:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "79:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "79:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "79:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "79:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "79:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "80:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "80:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "80:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "80:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "80:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "80:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "80:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "80:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "81:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "81:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "81:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "81:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "81:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "81:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "81:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "81:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "82:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "82:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "82:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "82:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "82:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "82:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "4n",
                    "time": "82:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "85:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "86:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "86:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "86:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "86:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "87:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "87:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "88:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "88:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "88:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "88:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "89:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "89:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "89:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "90:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "90:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "90:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "90:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "91:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "91:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "91:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "91:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "92:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "92:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "92:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "92:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "92:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "92:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "92:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "92:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "93:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "93:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "93:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "93:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "93:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "93:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "93:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "93:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "94:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "94:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "94:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "94:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "94:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "94:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "95:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "95:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "95:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "95:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "95:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "95:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "96:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "96:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "96:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "96:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "96:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "96:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "97:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "97:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "97:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "97:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "97:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "97:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "98:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "98:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "98:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "98:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "98:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "98:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "99:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "99:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "99:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "99:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "99:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "99:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "100:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "100:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "100:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "100:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "100:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "100:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "101:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "101:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "101:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "1m",
                    "time": "101:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "1m",
                    "time": "101:2:2",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "2013 Drum Kit",
            "notes": [
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "0:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "4:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "4:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "5:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "5:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "6:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "6:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "7:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "7:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "8:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "9:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "9:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "10:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "10:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "11:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "11:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "12:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "12:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "13:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "13:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "14:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "14:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "15:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "15:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "16:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "16:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "17:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "17:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "18:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "18:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "19:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "19:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "30:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "30:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "31:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "31:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "32:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "32:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "33:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "33:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "34:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "34:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "35:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "35:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "36:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "36:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "37:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "37:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "38:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "38:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "39:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "40:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "40:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "41:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "41:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "42:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "42:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "43:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "43:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "44:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "44:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "45:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "45:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "45:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "46:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "46:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "47:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "47:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "48:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "48:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "59:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "59:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "60:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "60:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "61:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "61:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "62:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "62:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "63:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "63:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "64:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "64:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "65:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "65:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "66:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "66:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "66:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "82:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "86:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "86:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "87:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "87:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "88:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "88:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "89:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "89:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "90:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "90:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "91:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "91:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "92:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "92:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "92:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "92:2:3",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "92:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "92:3:1",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "92:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "92:3:3",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "93:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "93:0:1",
                    "velocity": 0.16
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "93:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "93:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "93:0:3",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "93:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "93:1:1",
                    "velocity": 0.16
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "94:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "95:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "96:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "97:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "98:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "99:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "100:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "101:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "1m",
                    "time": "101:2:2",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "2023 Drum Kit",
            "notes": [
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "0:2:2",
                    "velocity": 0.54
                },
                {
                    "name": "E3",
                    "duration": "4n",
                    "time": "0:2:2",
                    "velocity": 0.31
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "0:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "19:2:2",
                    "velocity": 0.54
                },
                {
                    "name": "E3",
                    "duration": "4n",
                    "time": "19:2:2",
                    "velocity": 0.31
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "19:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "30:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "31:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "31:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "31:1:2",
                    "velocity": 0.27
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "31:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "31:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "32:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "32:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "32:3:2",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "33:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "33:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "34:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "35:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "35:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "35:1:2",
                    "velocity": 0.27
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "35:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "35:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "36:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "36:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "36:3:2",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "37:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "37:0:2",
                    "velocity": 0.27
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "37:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "38:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "39:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "40:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "41:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "42:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "43:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "44:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "45:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "48:2:2",
                    "velocity": 0.54
                },
                {
                    "name": "E3",
                    "duration": "4n",
                    "time": "48:2:2",
                    "velocity": 0.31
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "48:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "59:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "60:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "60:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "60:1:2",
                    "velocity": 0.27
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "60:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "60:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "61:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "61:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "61:3:2",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "62:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "62:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "63:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "64:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "64:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "64:1:2",
                    "velocity": 0.27
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "64:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "64:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "65:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "65:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "65:3:2",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "66:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "66:0:2",
                    "velocity": 0.27
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "66:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "66:2:2",
                    "velocity": 0.54
                },
                {
                    "name": "E3",
                    "duration": "4n",
                    "time": "66:2:2",
                    "velocity": 0.31
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "66:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "82:2:2",
                    "velocity": 0.54
                },
                {
                    "name": "E3",
                    "duration": "4n",
                    "time": "82:2:2",
                    "velocity": 0.31
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "82:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "86:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "87:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "87:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "87:1:2",
                    "velocity": 0.27
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "87:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "87:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "88:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "88:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "88:3:2",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "89:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "89:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "90:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "91:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "91:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "91:1:2",
                    "velocity": 0.27
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "91:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "91:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "92:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "92:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "92:3:2",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "93:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "93:0:2",
                    "velocity": 0.27
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "93:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "94:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "95:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "95:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "95:1:2",
                    "velocity": 0.27
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "95:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "95:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "96:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "96:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "96:3:2",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "97:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "97:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "98:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "99:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "99:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "99:1:2",
                    "velocity": 0.27
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "99:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "99:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "100:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "100:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "100:3:2",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "101:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "101:0:2",
                    "velocity": 0.27
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "101:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "1m",
                    "time": "101:2:2",
                    "velocity": 0.54
                },
                {
                    "name": "E3",
                    "duration": "1m",
                    "time": "101:2:2",
                    "velocity": 0.31
                },
                {
                    "name": "G#3",
                    "duration": "1m",
                    "time": "101:2:2",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "EDM Kit (E)",
            "notes": [
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "20:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "20:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "21:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "21:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "22:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "22:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "23:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "23:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "24:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "24:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "25:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "25:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "26:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "26:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "27:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "27:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "29:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "2n",
                    "time": "29:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "30:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "30:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "30:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#6",
                    "duration": "2n",
                    "time": "30:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "31:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "2n",
                    "time": "31:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "32:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "32:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "32:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#6",
                    "duration": "2n",
                    "time": "32:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "33:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "33:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "2n",
                    "time": "33:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "34:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "34:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "34:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#6",
                    "duration": "2n",
                    "time": "34:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "35:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "35:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "35:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "2n",
                    "time": "35:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "36:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "36:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "36:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#6",
                    "duration": "2n",
                    "time": "36:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "49:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "49:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "50:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "50:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "51:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "51:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "52:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "52:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "53:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "53:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "54:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "54:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "55:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "55:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "56:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "56:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "58:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "2n",
                    "time": "58:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "59:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "59:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "59:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#6",
                    "duration": "2n",
                    "time": "59:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "60:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "2n",
                    "time": "60:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "61:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "61:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "61:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#6",
                    "duration": "2n",
                    "time": "61:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "62:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "62:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "2n",
                    "time": "62:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "63:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "63:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "63:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#6",
                    "duration": "2n",
                    "time": "63:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "64:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "64:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "64:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "2n",
                    "time": "64:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "65:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "65:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "65:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#6",
                    "duration": "2n",
                    "time": "65:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "85:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "2n",
                    "time": "85:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "86:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "86:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "86:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#6",
                    "duration": "2n",
                    "time": "86:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "87:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "2n",
                    "time": "87:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "88:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "88:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "88:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#6",
                    "duration": "2n",
                    "time": "88:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "89:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "89:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "2n",
                    "time": "89:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "90:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "90:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "90:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#6",
                    "duration": "2n",
                    "time": "90:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "91:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "91:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "91:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "2n",
                    "time": "91:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "92:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#6",
                    "duration": "2n",
                    "time": "92:3:2",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "Bass Guitar",
            "notes": [
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "13:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "13:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "14:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "15:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "15:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "16:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "17:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "17:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "18:0:0",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "EDM Kit (E) 3",
            "notes": [
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "29:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "30:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "30:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "30:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "30:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "31:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "31:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "32:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "32:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "32:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "32:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "33:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "33:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "33:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "34:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "34:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "34:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "34:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "35:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "35:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "35:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "35:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "36:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "36:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "36:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "36:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "37:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "58:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "59:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "59:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "59:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "59:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "60:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "60:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "61:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "61:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "61:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "61:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "62:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "62:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "62:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "63:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "63:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "63:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "63:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "64:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "64:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "64:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "64:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "65:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "65:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "65:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "65:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "66:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "85:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "86:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "86:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "86:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "86:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "87:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "87:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "88:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "88:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "88:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "88:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "89:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "89:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "89:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "90:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "90:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "90:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "90:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "91:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "91:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "91:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "91:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "92:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "92:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "93:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "93:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "94:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "94:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "94:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "94:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "94:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "94:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "95:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "95:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "95:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "95:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "95:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "95:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "96:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "96:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "96:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "96:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "96:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "96:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "97:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "97:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "97:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "97:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "97:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "97:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "98:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "98:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "98:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "98:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "98:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "98:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "99:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "99:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "99:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "99:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "99:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "99:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "100:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "100:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "100:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "100:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "100:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "100:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "101:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "101:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "101:1:2",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "EDM Kit (E) 2",
            "notes": [
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "21:0:2",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "22:0:2",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "23:0:2",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "24:0:2",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "25:0:2",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "26:0:2",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "27:0:2",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "28:0:2",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "50:0:2",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "51:0:2",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "52:0:2",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "53:0:2",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "54:0:2",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "55:0:2",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "56:0:2",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "57:0:2",
                    "velocity": 0.31
                }
            ]
        },
        {
            "name": "8-Bit Sine",
            "notes": [
                {
                    "name": "C#4",
                    "duration": "2n",
                    "time": "29:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "2n",
                    "time": "58:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "2n",
                    "time": "85:0:2",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "Synth Bass",
            "notes": [
                {
                    "name": "C#1",
                    "duration": "8n",
                    "time": "29:2:2",
                    "velocity": 0.54
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "29:2:2",
                    "velocity": 0.54
                },
                {
                    "name": "C#1",
                    "duration": "8n",
                    "time": "31:2:2",
                    "velocity": 0.54
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "31:2:2",
                    "velocity": 0.54
                },
                {
                    "name": "C#1",
                    "duration": "8n",
                    "time": "33:2:2",
                    "velocity": 0.54
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "33:2:2",
                    "velocity": 0.54
                },
                {
                    "name": "C#1",
                    "duration": "8n",
                    "time": "35:2:2",
                    "velocity": 0.54
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "35:2:2",
                    "velocity": 0.54
                },
                {
                    "name": "C#1",
                    "duration": "8n",
                    "time": "37:2:2",
                    "velocity": 0.54
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "37:2:2",
                    "velocity": 0.54
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "39:2:2",
                    "velocity": 0.54
                },
                {
                    "name": "C#1",
                    "duration": "8n",
                    "time": "39:2:2",
                    "velocity": 0.54
                },
                {
                    "name": "C#1",
                    "duration": "8n",
                    "time": "41:2:2",
                    "velocity": 0.54
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "41:2:2",
                    "velocity": 0.54
                },
                {
                    "name": "C#1",
                    "duration": "8n",
                    "time": "43:2:2",
                    "velocity": 0.54
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "43:2:2",
                    "velocity": 0.54
                },
                {
                    "name": "C#1",
                    "duration": "8n",
                    "time": "58:2:2",
                    "velocity": 0.54
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "58:2:2",
                    "velocity": 0.54
                },
                {
                    "name": "C#1",
                    "duration": "8n",
                    "time": "60:2:2",
                    "velocity": 0.54
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "60:2:2",
                    "velocity": 0.54
                },
                {
                    "name": "C#1",
                    "duration": "8n",
                    "time": "62:2:2",
                    "velocity": 0.54
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "62:2:2",
                    "velocity": 0.54
                },
                {
                    "name": "C#1",
                    "duration": "8n",
                    "time": "64:2:2",
                    "velocity": 0.54
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "64:2:2",
                    "velocity": 0.54
                },
                {
                    "name": "C#1",
                    "duration": "8n",
                    "time": "85:2:2",
                    "velocity": 0.54
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "85:2:2",
                    "velocity": 0.54
                },
                {
                    "name": "C#1",
                    "duration": "8n",
                    "time": "87:2:2",
                    "velocity": 0.54
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "87:2:2",
                    "velocity": 0.54
                },
                {
                    "name": "C#1",
                    "duration": "8n",
                    "time": "89:2:2",
                    "velocity": 0.54
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "89:2:2",
                    "velocity": 0.54
                },
                {
                    "name": "C#1",
                    "duration": "8n",
                    "time": "91:2:2",
                    "velocity": 0.54
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "91:2:2",
                    "velocity": 0.54
                },
                {
                    "name": "C#1",
                    "duration": "8n",
                    "time": "93:2:2",
                    "velocity": 0.54
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "93:2:2",
                    "velocity": 0.54
                },
                {
                    "name": "C#1",
                    "duration": "8n",
                    "time": "95:2:2",
                    "velocity": 0.54
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "95:2:2",
                    "velocity": 0.54
                },
                {
                    "name": "C#1",
                    "duration": "8n",
                    "time": "97:2:2",
                    "velocity": 0.54
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "97:2:2",
                    "velocity": 0.54
                },
                {
                    "name": "C#1",
                    "duration": "8n",
                    "time": "99:2:2",
                    "velocity": 0.54
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "99:2:2",
                    "velocity": 0.54
                }
            ]
        },
        {
            "name": "Dist. Guitar (Classic)",
            "notes": [
                {
                    "name": "C#6",
                    "duration": "2n",
                    "time": "29:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#6",
                    "duration": "2n",
                    "time": "58:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#6",
                    "duration": "2n",
                    "time": "85:0:2",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "Brass",
            "notes": [
                {
                    "name": "F#2",
                    "duration": "2n",
                    "time": "66:2:2",
                    "velocity": 0.13
                },
                {
                    "name": "A2",
                    "duration": "2n",
                    "time": "67:2:2",
                    "velocity": 0.13
                },
                {
                    "name": "C#2",
                    "duration": "2n",
                    "time": "68:2:2",
                    "velocity": 0.13
                },
                {
                    "name": "B1",
                    "duration": "2n",
                    "time": "69:2:2",
                    "velocity": 0.13
                },
                {
                    "name": "F#2",
                    "duration": "2n",
                    "time": "70:2:2",
                    "velocity": 0.13
                },
                {
                    "name": "A2",
                    "duration": "2n",
                    "time": "71:2:2",
                    "velocity": 0.13
                },
                {
                    "name": "C#2",
                    "duration": "2n",
                    "time": "72:2:2",
                    "velocity": 0.13
                },
                {
                    "name": "G#1",
                    "duration": "2n",
                    "time": "73:2:2",
                    "velocity": 0.13
                },
                {
                    "name": "F#1",
                    "duration": "8n",
                    "time": "74:2:2",
                    "velocity": 0.13
                },
                {
                    "name": "F#1",
                    "duration": "8n",
                    "time": "75:0:2",
                    "velocity": 0.13
                },
                {
                    "name": "A1",
                    "duration": "8n",
                    "time": "75:2:2",
                    "velocity": 0.13
                },
                {
                    "name": "A1",
                    "duration": "8n",
                    "time": "76:0:2",
                    "velocity": 0.13
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "76:2:2",
                    "velocity": 0.13
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "77:0:2",
                    "velocity": 0.13
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "77:2:2",
                    "velocity": 0.13
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "78:0:2",
                    "velocity": 0.13
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "78:2:2",
                    "velocity": 0.13
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "78:3:2",
                    "velocity": 0.13
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "79:0:2",
                    "velocity": 0.13
                },
                {
                    "name": "F#1",
                    "duration": "8n",
                    "time": "79:1:2",
                    "velocity": 0.13
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "79:2:2",
                    "velocity": 0.13
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "79:3:2",
                    "velocity": 0.13
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "80:0:2",
                    "velocity": 0.13
                },
                {
                    "name": "A1",
                    "duration": "8n",
                    "time": "80:1:2",
                    "velocity": 0.13
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "80:2:2",
                    "velocity": 0.13
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "80:3:2",
                    "velocity": 0.13
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "81:0:2",
                    "velocity": 0.13
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "81:1:2",
                    "velocity": 0.13
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "81:2:2",
                    "velocity": 0.13
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "81:3:2",
                    "velocity": 0.13
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "82:0:2",
                    "velocity": 0.13
                },
                {
                    "name": "G#1",
                    "duration": "8n",
                    "time": "82:1:2",
                    "velocity": 0.13
                },
                {
                    "name": "C#2",
                    "duration": "1m",
                    "time": "82:2:2",
                    "velocity": 0.13
                }
            ]
        },
        {
            "name": "909 Drum Kit 2",
            "notes": [
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "24:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "24:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "24:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "24:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "8n",
                    "time": "24:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "24:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "25:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "25:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "25:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "25:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "25:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "25:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "25:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "25:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "8n",
                    "time": "25:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "25:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "25:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "25:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "25:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "25:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "25:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "25:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "8n",
                    "time": "25:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "25:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "26:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "26:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "26:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "26:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "26:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "26:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "26:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "26:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "8n",
                    "time": "26:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "26:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "26:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "26:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "26:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "26:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "26:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "26:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "8n",
                    "time": "26:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "26:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "27:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "27:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "27:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "27:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "27:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "27:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "27:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "27:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "8n",
                    "time": "27:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "27:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "27:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "27:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "27:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "27:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "27:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "27:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "8n",
                    "time": "27:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "27:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "28:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "28:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "28:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "28:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "28:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "53:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "53:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "53:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "53:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "8n",
                    "time": "53:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "53:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "54:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "54:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "54:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "54:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "54:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "54:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "54:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "54:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "8n",
                    "time": "54:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "54:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "54:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "54:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "54:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "54:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "54:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "54:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "8n",
                    "time": "54:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "54:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "55:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "55:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "55:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "55:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "55:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "55:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "55:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "55:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "8n",
                    "time": "55:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "55:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "55:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "55:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "55:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "55:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "55:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "55:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "8n",
                    "time": "55:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "55:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "56:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "56:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "56:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "56:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "56:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "56:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "56:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "56:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "8n",
                    "time": "56:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "56:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "56:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "56:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "56:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "56:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "56:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "56:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "8n",
                    "time": "56:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "56:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "57:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "57:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "57:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "57:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "57:0:2",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "Rumi",
            "notes": [
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "0:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "0:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "1:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "1:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "1:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "1:3:0",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "1:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "2:0:0",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "2:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "2:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "2:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "3:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "3:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "3:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "3:3:0",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "3:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "4:0:0",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "4:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "16:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "16:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "16:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "16:3:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "16:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "17:0:0",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "17:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "17:1:0",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "17:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "17:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "17:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "17:3:0",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "17:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "18:0:0",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "18:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "18:1:0",
                    "velocity": 0.65
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "18:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "18:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "4n",
                    "time": "18:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "2n",
                    "time": "19:0:0",
                    "velocity": 0.65
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "19:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "19:3:0",
                    "velocity": 0.65
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "19:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "20:0:0",
                    "velocity": 0.65
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "20:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "20:1:0",
                    "velocity": 0.65
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "20:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "20:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "C#5",
                    "duration": "8n",
                    "time": "20:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "2n",
                    "time": "20:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "21:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "21:3:0",
                    "velocity": 0.65
                },
                {
                    "name": "C#5",
                    "duration": "16n",
                    "time": "21:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "22:0:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "22:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "22:1:0",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "22:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "22:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "22:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "22:3:1",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "22:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "23:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "23:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "23:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "23:3:1",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "23:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "24:1:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "24:1:0",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "24:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "24:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "24:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "C#5",
                    "duration": "8n",
                    "time": "24:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "2n",
                    "time": "24:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "25:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "25:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "25:3:0",
                    "velocity": 0.65
                },
                {
                    "name": "C#5",
                    "duration": "16n",
                    "time": "25:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "26:0:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "26:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "26:1:0",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "26:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "26:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "26:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "26:3:1",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "26:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "27:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "27:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "27:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "27:3:1",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "27:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "28:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "28:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "28:2:3",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "28:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#5",
                    "duration": "8n",
                    "time": "29:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "29:1:0",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "29:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "29:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "33:0:2",
                    "velocity": 0.75
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "33:0:3",
                    "velocity": 0.75
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "33:1:2",
                    "velocity": 0.75
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "33:1:3",
                    "velocity": 0.75
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "33:2:2",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "36:3:2",
                    "velocity": 0.75
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "36:3:3",
                    "velocity": 0.75
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "37:0:0",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "4n",
                    "time": "37:0:2",
                    "velocity": 0.75
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "45:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "45:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "45:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "45:3:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "45:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "46:0:0",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "46:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "46:1:0",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "46:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "46:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "46:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "46:3:0",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "46:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "47:0:0",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "47:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "47:1:0",
                    "velocity": 0.65
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "47:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "47:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "4n",
                    "time": "47:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "2n",
                    "time": "48:0:0",
                    "velocity": 0.65
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "48:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "48:3:0",
                    "velocity": 0.65
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "48:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "49:0:0",
                    "velocity": 0.65
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "49:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "49:1:0",
                    "velocity": 0.65
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "49:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "49:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "C#5",
                    "duration": "4n",
                    "time": "49:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "2n",
                    "time": "49:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "E5",
                    "duration": "8n",
                    "time": "50:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "50:3:0",
                    "velocity": 0.65
                },
                {
                    "name": "C#5",
                    "duration": "16n",
                    "time": "50:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "51:0:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "51:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "51:1:0",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "51:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "51:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "51:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "51:3:1",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "2n",
                    "time": "51:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "52:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "52:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "52:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "52:3:1",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "52:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "53:1:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "53:1:0",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "53:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "53:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "53:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "C#5",
                    "duration": "8n",
                    "time": "53:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "2n",
                    "time": "53:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "54:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "54:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "54:3:0",
                    "velocity": 0.65
                },
                {
                    "name": "C#5",
                    "duration": "16n",
                    "time": "54:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "55:0:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "55:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "55:1:0",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "55:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "55:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "55:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "55:3:1",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "55:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "56:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "56:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "56:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "56:3:1",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "56:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "57:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "57:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "57:2:3",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "57:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#5",
                    "duration": "8n",
                    "time": "58:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "58:1:0",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "58:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "58:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "58:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "62:0:2",
                    "velocity": 0.75
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "62:0:3",
                    "velocity": 0.75
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "62:1:2",
                    "velocity": 0.75
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "62:1:3",
                    "velocity": 0.75
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "62:2:2",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "65:3:2",
                    "velocity": 0.75
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "65:3:3",
                    "velocity": 0.75
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "66:0:0",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "4n",
                    "time": "66:0:2",
                    "velocity": 0.75
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "67:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "67:1:0",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "67:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "67:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "B4",
                    "duration": "4n",
                    "time": "67:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "68:0:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "68:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "68:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "68:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "68:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "69:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "69:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "69:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "69:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "70:0:0",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "70:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "70:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "70:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "71:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "71:1:0",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "71:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "71:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "B4",
                    "duration": "4n",
                    "time": "71:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "72:0:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "72:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "72:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "72:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "72:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "73:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "73:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "73:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "73:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "74:0:0",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "74:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "74:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "74:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "75:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "75:1:1",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "75:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "D#4",
                    "duration": "4n",
                    "time": "75:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "76:0:0",
                    "velocity": 0.65
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "76:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "76:1:1",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "76:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "4n",
                    "time": "76:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "77:0:0",
                    "velocity": 0.65
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "77:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "77:1:1",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "77:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "77:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "77:3:1",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "78:0:0",
                    "velocity": 0.65
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "78:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "78:1:1",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "78:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "4n",
                    "time": "78:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "79:0:0",
                    "velocity": 0.65
                },
                {
                    "name": "C#5",
                    "duration": "4n",
                    "time": "79:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "79:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "79:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "80:0:0",
                    "velocity": 0.65
                },
                {
                    "name": "D#5",
                    "duration": "4n",
                    "time": "80:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "80:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "80:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#5",
                    "duration": "4n",
                    "time": "81:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "81:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "D#5",
                    "duration": "4n",
                    "time": "81:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#5",
                    "duration": "16n",
                    "time": "82:0:0",
                    "velocity": 0.65
                },
                {
                    "name": "C5",
                    "duration": "4n",
                    "time": "82:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "82:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "82:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "83:0:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "83:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "83:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "83:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "83:3:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "83:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "85:2:0",
                    "velocity": 0.75
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "85:2:1",
                    "velocity": 0.75
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "85:2:2",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "85:3:1",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "86:0:0",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "86:0:1",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "86:0:2",
                    "velocity": 0.75
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "86:1:0",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "86:1:2",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "86:2:0",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "86:2:1",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "86:2:2",
                    "velocity": 0.75
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "86:3:0",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "86:3:2",
                    "velocity": 0.75
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "87:0:0",
                    "velocity": 0.75
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "87:0:2",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "87:2:0",
                    "velocity": 0.75
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "87:2:1",
                    "velocity": 0.75
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "87:2:2",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "87:3:1",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "88:0:0",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "88:0:1",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "88:0:2",
                    "velocity": 0.75
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "88:1:0",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "88:1:2",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "88:2:0",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "88:2:1",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "88:2:2",
                    "velocity": 0.75
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "88:3:0",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "88:3:2",
                    "velocity": 0.75
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "89:0:0",
                    "velocity": 0.75
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "89:0:2",
                    "velocity": 0.75
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "89:2:0",
                    "velocity": 0.7
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "89:2:2",
                    "velocity": 0.7
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "89:2:3",
                    "velocity": 0.7
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "89:3:1",
                    "velocity": 0.7
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "89:3:2",
                    "velocity": 0.7
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "90:0:0",
                    "velocity": 0.7
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "90:0:2",
                    "velocity": 0.7
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "90:1:1",
                    "velocity": 0.7
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "90:1:4",
                    "velocity": 0.7
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "90:2:2",
                    "velocity": 0.7
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "90:3:1",
                    "velocity": 0.7
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "91:0:0",
                    "velocity": 0.7
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "91:0:2",
                    "velocity": 0.7
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "91:1:2",
                    "velocity": 0.7
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "91:2:0",
                    "velocity": 0.7
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "91:2:2",
                    "velocity": 0.7
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "91:2:4",
                    "velocity": 0.7
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "91:3:1",
                    "velocity": 0.7
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "91:3:2",
                    "velocity": 0.7
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "91:3:3",
                    "velocity": 0.7
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "92:0:2",
                    "velocity": 0.7
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "92:0:4",
                    "velocity": 0.7
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "92:1:1",
                    "velocity": 0.7
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "92:1:2",
                    "velocity": 0.7
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "92:1:3",
                    "velocity": 0.7
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "92:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "92:2:3",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "92:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#5",
                    "duration": "8n",
                    "time": "93:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "93:1:0",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "93:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "93:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "93:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "97:0:2",
                    "velocity": 0.75
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "97:0:3",
                    "velocity": 0.75
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "97:1:2",
                    "velocity": 0.75
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "97:1:3",
                    "velocity": 0.75
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "97:2:2",
                    "velocity": 0.75
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "101:0:2",
                    "velocity": 0.75
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "101:0:3",
                    "velocity": 0.75
                },
                {
                    "name": "F#4",
                    "duration": "4n",
                    "time": "101:1:2",
                    "velocity": 0.75
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "101:2:2",
                    "velocity": 0.75
                }
            ]
        },
        {
            "name": "Mira",
            "notes": [
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "3:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "3:3:3",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "4:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#5",
                    "duration": "8n",
                    "time": "4:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "8:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "8:3:0",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "8:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "9:0:0",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "9:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "9:1:0",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "9:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "9:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "9:3:0",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "9:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "10:0:0",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "10:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "10:1:0",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "10:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "10:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "10:3:0",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "10:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "11:0:0",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "11:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#5",
                    "duration": "16n",
                    "time": "11:1:0",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "11:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "11:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "11:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "11:3:0",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "11:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "12:0:0",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "12:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "14:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "14:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "14:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "14:3:0",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "14:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "15:0:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "15:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "15:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "15:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "15:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "15:3:0",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "15:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "16:0:0",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "20:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#3",
                    "duration": "2n",
                    "time": "20:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "22:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "22:3:1",
                    "velocity": 0.65
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "22:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "23:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "23:3:1",
                    "velocity": 0.65
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "23:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#3",
                    "duration": "16n",
                    "time": "24:1:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "24:1:0",
                    "velocity": 0.65
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "24:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "24:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "24:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "24:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#3",
                    "duration": "2n",
                    "time": "24:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "26:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "26:3:1",
                    "velocity": 0.65
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "26:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "27:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "27:3:1",
                    "velocity": 0.65
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "27:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "28:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "28:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "28:2:3",
                    "velocity": 0.65
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "28:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "29:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "29:1:0",
                    "velocity": 0.65
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "29:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "29:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "29:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "31:0:2",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "31:0:3",
                    "velocity": 0.75
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "31:1:2",
                    "velocity": 0.75
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "31:2:2",
                    "velocity": 0.75
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "35:0:2",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "35:0:3",
                    "velocity": 0.75
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "35:1:2",
                    "velocity": 0.75
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "35:2:2",
                    "velocity": 0.75
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "41:2:0",
                    "velocity": 0.7
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "41:2:2",
                    "velocity": 0.7
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "41:2:3",
                    "velocity": 0.7
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "41:3:1",
                    "velocity": 0.7
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "41:3:2",
                    "velocity": 0.7
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "42:0:0",
                    "velocity": 0.7
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "42:0:2",
                    "velocity": 0.7
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "42:1:1",
                    "velocity": 0.7
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "42:1:4",
                    "velocity": 0.7
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "42:2:2",
                    "velocity": 0.7
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "42:3:1",
                    "velocity": 0.7
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "43:0:0",
                    "velocity": 0.7
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "43:0:2",
                    "velocity": 0.7
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "43:1:2",
                    "velocity": 0.7
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "43:2:0",
                    "velocity": 0.7
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "43:2:2",
                    "velocity": 0.7
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "43:2:4",
                    "velocity": 0.7
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "43:3:1",
                    "velocity": 0.7
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "43:3:2",
                    "velocity": 0.7
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "43:3:3",
                    "velocity": 0.7
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "44:0:2",
                    "velocity": 0.7
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "44:0:4",
                    "velocity": 0.7
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "44:1:1",
                    "velocity": 0.7
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "44:1:2",
                    "velocity": 0.7
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "44:1:3",
                    "velocity": 0.7
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "44:2:2",
                    "velocity": 0.7
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "44:2:3",
                    "velocity": 0.7
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "44:3:1",
                    "velocity": 0.7
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "45:0:0",
                    "velocity": 0.7
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "45:0:2",
                    "velocity": 0.7
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "49:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#3",
                    "duration": "2n",
                    "time": "49:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "51:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "51:3:1",
                    "velocity": 0.65
                },
                {
                    "name": "G#3",
                    "duration": "2n",
                    "time": "51:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "52:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "52:3:1",
                    "velocity": 0.65
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "52:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#3",
                    "duration": "16n",
                    "time": "53:1:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "53:1:0",
                    "velocity": 0.65
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "53:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "53:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "53:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "53:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#3",
                    "duration": "2n",
                    "time": "53:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "55:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "55:3:1",
                    "velocity": 0.65
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "55:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "56:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "56:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "56:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "56:3:1",
                    "velocity": 0.65
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "56:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "60:0:2",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "60:0:3",
                    "velocity": 0.75
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "60:1:2",
                    "velocity": 0.75
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "60:2:2",
                    "velocity": 0.75
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "64:0:2",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "64:0:3",
                    "velocity": 0.75
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "64:1:2",
                    "velocity": 0.75
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "64:2:2",
                    "velocity": 0.75
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "80:0:0",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "80:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "80:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#3",
                    "duration": "2n",
                    "time": "80:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "4n",
                    "time": "81:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "81:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "D#4",
                    "duration": "4n",
                    "time": "81:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "82:0:0",
                    "velocity": 0.65
                },
                {
                    "name": "C4",
                    "duration": "4n",
                    "time": "82:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "82:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "82:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "95:0:2",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "95:0:3",
                    "velocity": 0.75
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "95:1:2",
                    "velocity": 0.75
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "95:2:2",
                    "velocity": 0.75
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "99:0:2",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "99:0:3",
                    "velocity": 0.75
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "99:1:2",
                    "velocity": 0.75
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "99:2:2",
                    "velocity": 0.75
                }
            ]
        },
        {
            "name": "Zoey",
            "notes": [
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "2:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "2:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "2:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "2:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "3:0:0",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "4n",
                    "time": "3:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "4:3:0",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "4:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "5:0:0",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "5:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "5:0:3",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "5:1:0",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "5:1:1",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "5:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "5:3:0",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "5:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "5:3:3",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "6:0:0",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "6:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "6:0:3",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "6:1:0",
                    "velocity": 0.65
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "6:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "6:3:0",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "6:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "7:0:0",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "7:0:1",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "7:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "7:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "7:1:3",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "7:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "7:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "7:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "8:0:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "8:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "8:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "12:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "12:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "12:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "12:3:0",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "12:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "13:0:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "13:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "13:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "13:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "13:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "13:3:0",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "13:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "14:0:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "20:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "2n",
                    "time": "20:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "22:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "22:3:1",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "4n",
                    "time": "22:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "23:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "23:3:1",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "4n",
                    "time": "23:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "24:1:0",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "24:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "24:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "24:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "2n",
                    "time": "24:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "26:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "26:3:1",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "4n",
                    "time": "26:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "27:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "27:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "27:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "27:3:1",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "4n",
                    "time": "27:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "28:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "28:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "28:2:3",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "28:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#5",
                    "duration": "8n",
                    "time": "29:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "29:1:0",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "29:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "29:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "37:2:0",
                    "velocity": 0.75
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "37:2:1",
                    "velocity": 0.75
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "37:2:2",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "37:3:1",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "38:0:0",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "38:0:1",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "38:0:2",
                    "velocity": 0.75
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "38:1:0",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "38:1:2",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "38:2:0",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "38:2:1",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "38:2:2",
                    "velocity": 0.75
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "38:3:0",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "38:3:2",
                    "velocity": 0.75
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "39:0:0",
                    "velocity": 0.75
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "39:0:2",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "39:2:0",
                    "velocity": 0.75
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "39:2:1",
                    "velocity": 0.75
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "39:2:2",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "39:3:1",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "40:0:0",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "40:0:1",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "40:0:2",
                    "velocity": 0.75
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "40:1:0",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "40:1:2",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "40:2:0",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "40:2:1",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "40:2:2",
                    "velocity": 0.75
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "40:3:0",
                    "velocity": 0.75
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "40:3:2",
                    "velocity": 0.75
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "41:0:0",
                    "velocity": 0.75
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "41:0:2",
                    "velocity": 0.75
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "49:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "2n",
                    "time": "49:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "51:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "51:3:1",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "4n",
                    "time": "51:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "52:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "52:3:1",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "4n",
                    "time": "52:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "53:1:0",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "53:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "53:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "53:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "2n",
                    "time": "53:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "55:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "55:3:1",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "4n",
                    "time": "55:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "56:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "56:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "56:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "56:3:1",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "4n",
                    "time": "56:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "80:0:0",
                    "velocity": 0.65
                },
                {
                    "name": "B4",
                    "duration": "4n",
                    "time": "80:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "80:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "E4",
                    "duration": "2n",
                    "time": "80:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#5",
                    "duration": "4n",
                    "time": "81:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#5",
                    "duration": "16n",
                    "time": "81:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "C5",
                    "duration": "4n",
                    "time": "81:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "82:0:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "82:0:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "82:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "82:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "84:1:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "84:2:0",
                    "velocity": 0.65
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "84:2:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "84:3:0",
                    "velocity": 0.65
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "84:3:2",
                    "velocity": 0.65
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "85:0:0",
                    "velocity": 0.65
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "85:0:2",
                    "velocity": 0.65
                }
            ]
        },
        {
            "name": "All",
            "notes": [
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "29:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "29:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "29:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "29:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "30:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "30:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "30:1:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "30:1:2",
                    "velocity": 0.61
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "30:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "30:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "30:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "30:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "31:0:0",
                    "velocity": 0.61
                },
                {
                    "name": "F#2",
                    "duration": "8n",
                    "time": "31:0:0",
                    "velocity": 0.61
                },
                {
                    "name": "G#3",
                    "duration": "2n",
                    "time": "31:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#2",
                    "duration": "2n",
                    "time": "31:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "31:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "31:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "31:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "31:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "32:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "32:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "32:1:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "32:1:2",
                    "velocity": 0.61
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "32:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "32:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "32:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "32:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "33:0:0",
                    "velocity": 0.61
                },
                {
                    "name": "B2",
                    "duration": "8n",
                    "time": "33:0:0",
                    "velocity": 0.61
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "33:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "33:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "33:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "33:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "33:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "33:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "34:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "34:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "34:1:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "34:1:2",
                    "velocity": 0.61
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "34:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "34:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "34:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "34:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "35:0:0",
                    "velocity": 0.61
                },
                {
                    "name": "F#2",
                    "duration": "8n",
                    "time": "35:0:0",
                    "velocity": 0.61
                },
                {
                    "name": "G#3",
                    "duration": "2n",
                    "time": "35:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#2",
                    "duration": "2n",
                    "time": "35:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "35:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "35:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "35:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "35:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "36:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "36:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "36:1:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "36:1:2",
                    "velocity": 0.61
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "36:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "36:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "36:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "36:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "37:0:0",
                    "velocity": 0.61
                },
                {
                    "name": "B2",
                    "duration": "8n",
                    "time": "37:0:0",
                    "velocity": 0.61
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "37:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "37:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "58:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "58:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "58:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "58:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "59:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "59:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "59:1:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "59:1:2",
                    "velocity": 0.61
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "59:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "59:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "59:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "59:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "60:0:0",
                    "velocity": 0.61
                },
                {
                    "name": "F#2",
                    "duration": "8n",
                    "time": "60:0:0",
                    "velocity": 0.61
                },
                {
                    "name": "G#3",
                    "duration": "2n",
                    "time": "60:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#2",
                    "duration": "2n",
                    "time": "60:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "60:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "60:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "60:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "60:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "61:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "61:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "61:1:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "61:1:2",
                    "velocity": 0.61
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "61:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "61:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "61:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "61:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "62:0:0",
                    "velocity": 0.61
                },
                {
                    "name": "B2",
                    "duration": "8n",
                    "time": "62:0:0",
                    "velocity": 0.61
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "62:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "62:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "62:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "62:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "62:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "62:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "63:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "63:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "63:1:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "63:1:2",
                    "velocity": 0.61
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "63:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "63:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "63:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "63:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "64:0:0",
                    "velocity": 0.61
                },
                {
                    "name": "F#2",
                    "duration": "8n",
                    "time": "64:0:0",
                    "velocity": 0.61
                },
                {
                    "name": "G#3",
                    "duration": "2n",
                    "time": "64:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#2",
                    "duration": "2n",
                    "time": "64:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "64:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "64:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "64:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "64:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "65:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "65:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "65:1:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "65:1:2",
                    "velocity": 0.61
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "65:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "65:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "65:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "65:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "66:0:0",
                    "velocity": 0.61
                },
                {
                    "name": "B2",
                    "duration": "8n",
                    "time": "66:0:0",
                    "velocity": 0.61
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "66:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "66:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "93:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "93:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "93:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "93:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "94:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "94:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "94:1:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "94:1:2",
                    "velocity": 0.61
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "94:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "94:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "94:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "94:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "95:0:0",
                    "velocity": 0.61
                },
                {
                    "name": "F#2",
                    "duration": "8n",
                    "time": "95:0:0",
                    "velocity": 0.61
                },
                {
                    "name": "G#3",
                    "duration": "2n",
                    "time": "95:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#2",
                    "duration": "2n",
                    "time": "95:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "95:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "95:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "95:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "95:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "96:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "96:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "96:1:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "96:1:2",
                    "velocity": 0.61
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "96:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "96:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "96:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "96:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "97:0:0",
                    "velocity": 0.61
                },
                {
                    "name": "B2",
                    "duration": "8n",
                    "time": "97:0:0",
                    "velocity": 0.61
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "97:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "97:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "97:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "97:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "97:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "97:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "98:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "98:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "98:1:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "98:1:2",
                    "velocity": 0.61
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "98:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "98:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "98:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "98:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "99:0:0",
                    "velocity": 0.61
                },
                {
                    "name": "F#2",
                    "duration": "8n",
                    "time": "99:0:0",
                    "velocity": 0.61
                },
                {
                    "name": "G#3",
                    "duration": "2n",
                    "time": "99:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#2",
                    "duration": "2n",
                    "time": "99:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "99:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "99:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "99:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "99:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "100:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "100:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "100:1:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "100:1:2",
                    "velocity": 0.61
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "100:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "100:2:2",
                    "velocity": 0.61
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "100:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "100:3:2",
                    "velocity": 0.61
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "101:0:0",
                    "velocity": 0.61
                },
                {
                    "name": "B2",
                    "duration": "8n",
                    "time": "101:0:0",
                    "velocity": 0.61
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "101:0:2",
                    "velocity": 0.61
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "101:0:2",
                    "velocity": 0.61
                }
            ]
        },
        {
            "name": "Pop Synth",
            "notes": [
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "12:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "13:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "13:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "14:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "14:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "8n",
                    "time": "14:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "14:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "14:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "15:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "15:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "15:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "16:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "16:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "8n",
                    "time": "16:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "16:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "16:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "17:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "17:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "18:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "18:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "8n",
                    "time": "18:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "18:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "18:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "19:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "29:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "29:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#5",
                    "duration": "4n",
                    "time": "30:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "30:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "30:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "30:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "31:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "2n",
                    "time": "31:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "31:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "31:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#5",
                    "duration": "4n",
                    "time": "32:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "32:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "32:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "32:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "33:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "33:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "33:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "33:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#5",
                    "duration": "4n",
                    "time": "34:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "34:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "34:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "34:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "35:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "2n",
                    "time": "35:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "35:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "35:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#5",
                    "duration": "4n",
                    "time": "36:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "36:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "36:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "36:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "37:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "37:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "37:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "37:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "38:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "38:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "38:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "38:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "8n",
                    "time": "39:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "2n",
                    "time": "39:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "39:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "39:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "40:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "40:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "40:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "40:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "8n",
                    "time": "41:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "2n",
                    "time": "41:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "41:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "41:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "42:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "42:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "42:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "42:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "8n",
                    "time": "43:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "2n",
                    "time": "43:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "43:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "43:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "44:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "44:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "44:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "44:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "8n",
                    "time": "45:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "2n",
                    "time": "45:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "45:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "46:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "46:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "47:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "47:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "8n",
                    "time": "47:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "47:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "47:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "48:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "58:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "58:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#5",
                    "duration": "4n",
                    "time": "59:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "59:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "59:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "59:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "60:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "2n",
                    "time": "60:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "60:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "60:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#5",
                    "duration": "4n",
                    "time": "61:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "61:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "61:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "61:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "62:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "62:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "62:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "62:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#5",
                    "duration": "4n",
                    "time": "63:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "63:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "63:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "63:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "64:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "2n",
                    "time": "64:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "64:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "64:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#5",
                    "duration": "4n",
                    "time": "65:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "65:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "65:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "65:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "66:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "66:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "2n",
                    "time": "66:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "A2",
                    "duration": "2n",
                    "time": "67:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "2n",
                    "time": "68:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "B1",
                    "duration": "2n",
                    "time": "69:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "F#2",
                    "duration": "2n",
                    "time": "70:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "A2",
                    "duration": "2n",
                    "time": "71:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "2n",
                    "time": "72:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#1",
                    "duration": "2n",
                    "time": "73:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "F#1",
                    "duration": "8n",
                    "time": "74:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "F#1",
                    "duration": "8n",
                    "time": "74:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "F#1",
                    "duration": "8n",
                    "time": "75:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "A1",
                    "duration": "8n",
                    "time": "75:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "A1",
                    "duration": "8n",
                    "time": "75:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "A1",
                    "duration": "8n",
                    "time": "76:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "76:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "76:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "8n",
                    "time": "77:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "77:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "77:3:2",
                    "velocity": 0.32
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "78:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "78:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "78:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "79:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "79:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "79:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "79:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "80:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "80:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "80:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "80:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "81:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "81:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "81:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "81:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "82:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "82:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "C#2",
                    "duration": "1m",
                    "time": "82:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "85:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "85:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#5",
                    "duration": "4n",
                    "time": "86:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "86:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "86:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "86:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "87:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "2n",
                    "time": "87:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "87:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "87:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#5",
                    "duration": "4n",
                    "time": "88:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "88:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "88:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "88:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "89:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "89:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "89:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "89:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#5",
                    "duration": "4n",
                    "time": "90:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "90:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "90:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "90:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "91:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "2n",
                    "time": "91:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "91:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "91:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#5",
                    "duration": "4n",
                    "time": "92:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "92:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "92:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "92:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "93:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "93:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "93:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "93:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#5",
                    "duration": "4n",
                    "time": "94:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "94:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "94:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "94:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "95:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "2n",
                    "time": "95:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "95:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "95:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#5",
                    "duration": "4n",
                    "time": "96:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "96:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "96:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "96:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "97:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "97:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "97:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "97:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#5",
                    "duration": "4n",
                    "time": "98:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "98:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "98:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "98:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "99:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "2n",
                    "time": "99:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "99:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "99:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#5",
                    "duration": "4n",
                    "time": "100:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "100:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "100:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "100:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "101:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "101:0:2",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "Smooth Synth",
            "notes": [
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "0:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "0:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "0:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "0:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "0:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "0:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "1:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "1:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#5",
                    "duration": "4n",
                    "time": "1:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "1:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "1:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "1:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "1:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "1:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "1:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "1:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "1:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "1:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "2:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "8n",
                    "time": "2:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "2:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "2n",
                    "time": "2:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "2n",
                    "time": "2:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "2n",
                    "time": "2:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "2:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "2:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "2:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "2:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "2:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "2:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "3:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "3:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#5",
                    "duration": "4n",
                    "time": "3:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "3:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "3:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "3:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "3:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "3:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "3:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "3:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "3:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "4:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "8n",
                    "time": "4:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "4:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "4:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "4:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "4:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "16:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "16:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#5",
                    "duration": "8n",
                    "time": "16:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#5",
                    "duration": "8n",
                    "time": "16:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "16:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "17:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "17:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "17:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "17:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "17:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "17:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "17:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "17:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "18:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "18:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "18:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "18:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "18:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "B4",
                    "duration": "4n",
                    "time": "18:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "G#4",
                    "duration": "2n",
                    "time": "19:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "29:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "29:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "29:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "29:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "30:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "30:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "30:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "30:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "30:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "30:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "30:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "30:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "8n",
                    "time": "31:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "31:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "2n",
                    "time": "31:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "2n",
                    "time": "31:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "31:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "31:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "31:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "31:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "32:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "32:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "32:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "32:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "32:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "32:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "32:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "32:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "8n",
                    "time": "33:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "33:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "33:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "33:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "33:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "33:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "33:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "33:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "34:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "34:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "34:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "34:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "34:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "34:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "34:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "34:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "35:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "8n",
                    "time": "35:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "2n",
                    "time": "35:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "2n",
                    "time": "35:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "35:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "35:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "35:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "35:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "36:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "36:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "36:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "36:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "36:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "36:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "36:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "36:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "37:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "8n",
                    "time": "37:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "37:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "37:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "45:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "45:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#5",
                    "duration": "8n",
                    "time": "45:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#5",
                    "duration": "8n",
                    "time": "45:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "45:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "46:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "46:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "46:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "46:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "46:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "46:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "46:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "46:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "47:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "47:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "47:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "47:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "47:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "B4",
                    "duration": "4n",
                    "time": "47:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "G#4",
                    "duration": "2n",
                    "time": "48:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "58:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "58:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "58:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "58:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "59:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "59:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "59:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "59:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "59:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "59:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "59:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "59:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "8n",
                    "time": "60:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "60:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "2n",
                    "time": "60:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "2n",
                    "time": "60:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "60:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "60:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "60:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "60:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "61:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "61:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "61:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "61:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "61:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "61:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "61:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "61:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "8n",
                    "time": "62:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "62:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "62:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "62:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "62:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "62:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "62:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "62:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "63:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "63:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "63:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "63:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "63:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "63:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "63:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "63:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "64:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "8n",
                    "time": "64:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "2n",
                    "time": "64:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "2n",
                    "time": "64:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "64:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "64:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "64:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "64:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "65:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "65:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "65:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "65:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "65:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "65:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "65:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "65:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "66:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "8n",
                    "time": "66:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "66:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "66:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#5",
                    "duration": "2n",
                    "time": "66:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "A5",
                    "duration": "2n",
                    "time": "67:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#5",
                    "duration": "2n",
                    "time": "68:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "B4",
                    "duration": "2n",
                    "time": "69:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "F#5",
                    "duration": "2n",
                    "time": "70:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "A5",
                    "duration": "2n",
                    "time": "71:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "C#5",
                    "duration": "2n",
                    "time": "72:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "G#4",
                    "duration": "2n",
                    "time": "73:2:2",
                    "velocity": 0.32
                },
                {
                    "name": "F#5",
                    "duration": "1m",
                    "time": "74:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "A5",
                    "duration": "1m",
                    "time": "75:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "C#6",
                    "duration": "1m",
                    "time": "76:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "B5",
                    "duration": "2n",
                    "time": "77:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "A5",
                    "duration": "8n",
                    "time": "78:0:2",
                    "velocity": 0.12
                },
                {
                    "name": "G#5",
                    "duration": "4n",
                    "time": "78:1:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#5",
                    "duration": "1m",
                    "time": "78:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "A5",
                    "duration": "1m",
                    "time": "79:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "C#6",
                    "duration": "1m",
                    "time": "80:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "G#5",
                    "duration": "1m",
                    "time": "81:2:2",
                    "velocity": 0.12
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "85:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "85:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "85:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "85:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "86:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "86:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "86:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "86:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "86:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "86:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "86:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "86:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "8n",
                    "time": "87:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "87:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "2n",
                    "time": "87:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "2n",
                    "time": "87:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "87:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "87:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "87:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "87:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "88:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "88:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "88:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "88:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "88:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "88:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "88:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "88:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "8n",
                    "time": "89:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "89:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "89:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "89:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "89:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "89:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "89:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "89:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "90:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "90:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "90:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "90:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "90:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "90:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "90:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "90:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "91:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "8n",
                    "time": "91:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "2n",
                    "time": "91:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "2n",
                    "time": "91:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "91:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "91:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "91:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "91:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "92:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "92:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "92:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "92:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "92:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "92:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "92:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "93:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "8n",
                    "time": "93:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "93:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "93:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "93:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "93:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "93:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "93:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "94:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "94:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "94:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "94:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "94:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "94:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "94:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "94:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "8n",
                    "time": "95:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "95:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "2n",
                    "time": "95:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "2n",
                    "time": "95:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "95:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "95:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "95:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "95:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "96:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "96:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "96:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "96:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "96:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "96:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "96:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "96:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "8n",
                    "time": "97:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "97:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "97:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "97:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "97:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "97:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "97:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "97:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "98:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "98:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "98:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "98:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "98:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "98:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "98:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "98:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "99:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "8n",
                    "time": "99:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "2n",
                    "time": "99:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "2n",
                    "time": "99:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "99:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "4n",
                    "time": "99:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "99:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "99:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "100:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "4n",
                    "time": "100:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "100:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "100:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "100:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "100:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "100:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "100:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "101:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "8n",
                    "time": "101:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "4n",
                    "time": "101:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "4n",
                    "time": "101:0:2",
                    "velocity": 0.39
                }
            ]
        }
    ],
    structure: [
        { type: 'INTRO', duration: 16, rhythm: 'MINIMAL', lyrics: ["(Takedown...)", "(HUNTR/X...)", "Ready or not."] },
        { type: 'VERSE', duration: 32, rhythm: 'TRAP', lyrics: ["So sweet, so easy on the eyes", "But hideous on the inside", "I'm 'bout to switch up the vibes", "Watch your back, surprise!"] },
        { type: 'PRE_CHORUS', duration: 16, rhythm: 'BUILDUP', lyrics: ["'Cause I see your real face, and it's ugly as sin", "I don't think you're ready for the takedown"] },
        { type: 'CHORUS', duration: 32, rhythm: 'TRAP', lyrics: ["I'ma gear up and take you DOWN!", "It's a TAKEDOWN", "Take it down!", "Show you who wears the crown"] },
        { type: 'VERSE', duration: 32, rhythm: 'TRAP', lyrics: ["Yeah, look at me now", "Jeongsineul noko neol jitbalgo (Crushing your spirit)", "Aiming for the top, never gonna stop", "Click clack, bang bang, you drop"] },
        { type: 'PRE_CHORUS', duration: 16, rhythm: 'BUILDUP', lyrics: ["'Cause I see your real face...", "Ugly as sin...", "Ready for the takedown?"] },
        { type: 'CHORUS', duration: 32, rhythm: 'TRAP', lyrics: ["I'ma gear up and take you DOWN!", "It's a TAKEDOWN", "Take it down!", "Show you who wears the crown"] },
        { type: 'BRIDGE', duration: 16, rhythm: 'MINIMAL', lyrics: ["No mercy.", "No pity.", "Just victory.", "(Get ready!)"] },
        { type: 'DROP', duration: 32, rhythm: 'TRAP', lyrics: ["(GRRRAH!)", "Pop pop!", "Get down!", "It's a TAKEDOWN!"] },
        { type: 'OUTRO', duration: 16, rhythm: 'MINIMAL', lyrics: ["Takedown.", "Game over."] }
    ],
    musicalData: {
        keyRoot: "C#",
        scale: "minor",
        bpm: 140,
        defaultTheme: {
            chordProgression: [0, 5],
            bassPattern: [1, 0, 0, 0, 1, 0, 0, 0],
            melodyPattern: [0, null, 0, null, 3, 2, 0, null]
        },
        themes: {
            INTRO: {
                chordProgression: [0, 0],
                bassPattern: [1, 0, 0, 0, 0, 0, 0, 0],
                melodyPattern: [0, 0, 12, 0, 0, 12, 0, null, 0, 0, 12, 0, 3, 2, 0, null]
            },
            VERSE: {
                // Spooky, sparse. i - VI
                chordProgression: [0, 5], 
                bassPattern: [1, 0, 0, 0, 0, 0, 1, 0, 1, 0, 0, 0, 0, 0, 0, 0], // Sparse 808
                melodyPattern: [0, 0, null, 0, 0, null, 3, 0, null, null, null, null, null, null, null, null]
            },
            PRE_CHORUS: {
                // Building tension. VI - VII
                chordProgression: [5, 6], 
                bassPattern: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1], // Driving
                melodyPattern: [5, 5, 5, 5, 7, 7, 7, 7, 8, 8, 8, 8, 12, 12, 12, 12]
            },
            CHORUS: {
                // Aggressive Drop. i - VI - III - VII
                chordProgression: [0, 5, 2, 6], 
                bassPattern: [1, 0, 0, 1, 0, 0, 1, 0, 1, 0, 0, 1, 0, 0, 1, 1], // Heavy Trap Beat
                // "Gear up and take you down"
                melodyPattern: [0, 0, 3, 2, 0, -2, 0, 7, null, 7, null, 7, 0, 0, 0, 0]
            },
            BRIDGE: {
                chordProgression: [0, 0],
                bassPattern: [1, 0, 0, 0, 1, 0, 0, 0],
                melodyPattern: [0, 3, 5, 7, 8, 7, 5, 3, 0, null, null, null, null, null, null, null]
            },
            DROP: {
                chordProgression: [0, 0, 5, 5],
                bassPattern: [1, 0, 1, 0, 1, 0, 1, 0],
                melodyPattern: [12, 12, 12, null, 11, 11, 11, null, 7, 7, 7, 0, 0, 0, 12, 0]
            }
        }
    }
};
